import { Component, HostBinding } from '@angular/core';


@Component({
  selector: 'mui-sidebar-page-content',
  template: '<ng-content></ng-content>'
})
export class MuiSidebarPageContent {
  @HostBinding('attr.role')
  protected readonly _role = 'region';

  @HostBinding('class.mui-sidebar-page__content')
  protected readonly _baseClass = true;
}
